import { BookkeepingDetailApp } from "bookkeeping/detail/app";
import BookkeepingListApp from "bookkeeping/List/App";
import BookkeepingNewApp from "bookkeeping/new/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const bookkeepingRoute: RouteObject = {
  path: "bookkeeping",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: BookkeepingListApp,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: BookkeepingNewApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: BookkeepingDetailApp,
  }]
};